import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Container,
} from "reactstrap";
import { usersignupApi, userloginApi, userDataUpdateApi } from "../../doctorapi";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom"
import { FullWrap, FormWrap, Heading, LoginButton } from "../Userlogin/styles";

const UserSignup = ({ location }) => {
    const [userDetails, setUserDetails] = useState({
        username: "",
        email: "",
        password: "",
        confirm_password: ""
    })
    const search = location.search.substring(1);
    const params = Object.fromEntries(new URLSearchParams(search));

    useEffect(() => {
        if (params.email && params.id) {
            setUserDetails({ ...userDetails, email: params.email })
        }
    }, []);

    const Usersign = (e) => {
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value })
    }
    let history = useHistory()
    const disable = !userDetails.password || userDetails.password !== userDetails.confirm_password || !userDetails.email || !userDetails.username
    const handlesubmit = () => {
        const data = {
            firstname: userDetails.username,
            email: userDetails.email,
            password: userDetails.password,
            ...(params.id && params.email && { id: params.id })
        }
        // const apiCall = (
        //     params.email && params.id ?
        //         userDataUpdateApi
        //         : usersignupApi
        // )
        userDataUpdateApi(data).then(response => {
            if (response.data.statusCode === 200) {
                const loginValues = {
                    email: userDetails.email,
                    password: userDetails.password
                }
                userloginApi(loginValues).then(response => {
                    if (response.data.statusCode === 200) {
                        localStorage.setItem("token", JSON.stringify(response.data.body.token))
                        history.push("/user")
                        toast.success("User signup Successfully")
                    } else {
                        toast.error("something went wrong")
                    }
                })
                setUserDetails({
                    username: "",
                    email: "",
                    password: "",
                    confirm_password: ""
                })
            } else {
                toast.error("something went wrong")
            }
        }).catch(error => {
            toast.error(error.response.data.body.error.description || "something went wrong")
        })
    }

    if (!params.email || !params.id) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Page not found
            </div>
        )
    }
    return (
        <FullWrap>
            <Container>
                <FormWrap>
                    <Form
                        action=""
                        className="form"
                        method=""
                        autoComplete="off">
                        <Heading>Signup as User</Heading>
                        <Input
                            placeholder="Username"
                            type="text"
                            name="username"
                            value={userDetails.username}
                            onChange={(e) => Usersign(e)}
                        />
                        <Input
                            placeholder="Email"
                            type="email"
                            name="email"
                            value={userDetails.email || params.email}
                            onChange={(e) => Usersign(e)}
                            disabled={params.email}
                        />
                        <Input
                            placeholder="Password"
                            type="password"
                            name="password"
                            value={userDetails.password}
                            autoComplete="password"
                            onChange={(e) => Usersign(e)}
                        />
                        <Input
                            placeholder="Confirm Password"
                            type="password"
                            name="confirm_password"
                            value={userDetails.confirm_password}
                            autoComplete="Confirm-password"
                            onChange={(e) => Usersign(e)}
                        />
                        <LoginButton
                            block
                            onClick={(e) => handlesubmit(e)}
                            disabled={disable}
                        >
                            Signup
                        </LoginButton>
                    </Form>
                </FormWrap>
            </Container>
        </FullWrap>
    );
};

export default UserSignup;


// WEBPACK FOOTER //
// ./src/component/UserSignup/index.js